import { render } from "./Nav.vue?vue&type=template&id=7277ae2a&scoped=true"
import script from "./Nav.vue?vue&type=script&lang=js"
export * from "./Nav.vue?vue&type=script&lang=js"

import "./Nav.vue?vue&type=style&index=0&id=7277ae2a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Benjamin\\Desktop\\Hudplejeklinikken Esbjerg\\code\\hpke\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7277ae2a"]])

export default __exports__